import {makeBFFApiUrl} from 'main/factories/http';
import {RemoteGetRegistrationUpdateStatus} from 'data/usecases/private/home/registration-update-status';
import {GetRegistrationUpdateStatus} from 'domain/usecases/private/home/registration-update-status';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {HomeEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetRegistrationUpdateStatus = (): GetRegistrationUpdateStatus =>
	new RemoteGetRegistrationUpdateStatus(
		makeBFFApiUrl(HomeEndPoints.registrationUpdateStatus),
		makeAuthorizeHttpClientDecorator(),
	);
